import cn from 'clsx';
import {NeedHelp} from './NeedHelp';
import {FrequentlyAskedQuestions} from './FrequentlyAskedQuestions';

type Props = {
  className?: string;
};
export const EsimHelp = ({className}: Props) => {
  return (
    <div className={cn(className, 'flex flex-col gap-8')}>
      <NeedHelp className="w-full" />
      <FrequentlyAskedQuestions className="w-full" />
    </div>
  );
};
